import type { PageTypeResult } from 'src/hooks/usePageType'
import { dispatchAmplitudeEvent } from 'src/utils/amplitude'
import { getFeatureObject } from 'src/utils/amplitude/getFeatureObject'
import { getStandardObject } from 'src/utils/amplitude/getStandardObject'

export function sendShippingEvent({
  eventName,
  pageData,
}: {
  eventName: string
  pageData: PageTypeResult
}) {
  const featureObject = getFeatureObject({
    section: 'simulação de frete',
    locationOnPage: 'pdp',
    name: eventName,
  })

  const eventData = {
    ...getStandardObject(pageData),
    ...featureObject,
  }

  dispatchAmplitudeEvent({ eventName: 'Product Feature Viewed', eventData })
}
